import React, { useState, useEffect, useCallback } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button, Form, Image } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { api_url } from "../api/config/config";

const prefs = [
    "北海道",
    "青森県",
    "岩手県",
    "宮城県",
    "秋田県",
    "山形県",
    "福島県",
    "茨城県",
    "栃木県",
    "群馬県",
    "埼玉県",
    "千葉県",
    "東京都",
    "神奈川県",
    "新潟県",
    "富山県",
    "石川県",
    "福井県",
    "山梨県",
    "長野県",
    "岐阜県",
    "静岡県",
    "愛知県",
    "三重県",
    "滋賀県",
    "京都府",
    "大阪府",
    "兵庫県",
    "奈良県",
    "和歌山県",
    "鳥取県",
    "島根県",
    "岡山県",
    "広島県",
    "山口県",
    "徳島県",
    "香川県",
    "愛媛県",
    "高知県",
    "福岡県",
    "佐賀県",
    "長崎県",
    "熊本県",
    "大分県",
    "宮崎県",
    "鹿児島県",
    "沖縄県"
]

const VendorEdit: React.FC = () => {

    const navigate = useNavigate();
    const { userInfo, userToken, error } = useSelector((state: RootState) => state.auth);
    const { vendorInfo, loading: vendorLoading, error: vendorError } = useSelector((state: RootState) => state.vendor);

    const [isConfirmed, setIsConfirmed] = useState(false);
    const [name, setName] = useState('');
    const [vendorId, setVendorId] = useState('');
    const [postcode, setPostcode] = useState('');
    const [address1, setAddress1] = useState('');
    const [address2, setAddress2] = useState('');
    const [phone, setPhone] = useState('');
    const [pref, setPref] = useState('');

    const fetchVendorById = async (vendor_id: number) => {
        const response = await fetch(`${api_url}/getVendorById`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ vendor_id: vendor_id }),
        });

        const res: any = await response.json();
        return res.data;
    }

    const fetchVendorInfo = useCallback(async () => {
        try {
            if (vendorInfo) {
                const vendor = await fetchVendorById(vendorInfo?.vendor_id);
                setName(vendor.name);
                setVendorId(vendor.id);
                setPostcode(vendor.post_code);
                setAddress1(vendor.address1);
                setAddress2(vendor.address2);
                setPhone(vendor.phone);
                setPref(vendor.prefecture);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }, [])

    const handleConfirm = () => {
        if (name && postcode && pref && address1 && address2 && phone) {
            setIsConfirmed(true);
        } else {
            alert('必須項目を全て入力してください');
        }
    }

    const handleSubmit = async (event: { preventDefault: () => void; }) => {
        event.preventDefault()
        try {

            const response = await fetch(`${api_url}/updateVendorById`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: vendorId,
                    name: name,
                    post_code: postcode,
                    pref: pref,
                    address1: address1,
                    address2: address2,
                    phone: phone,
                    userToken: userToken
                }),
            });

            const res = await response.json();
            navigate('/vendor_edit_completed');
        } catch (error) {
            console.error('Error:', error);
        }
    }

    useEffect(() => {
        fetchVendorInfo();
    }, [fetchVendorInfo])


    return (
        <>
            <section className="">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-10 mx-auto">
                            <div className="login-wrapper py-lg-5 py-3 text-center">
                                <Image className="height-90 mb-2" src="assets/images/other/icon-building-bg-white-circle-blue.svg" />
                                <div className="text-md mb-sm-4 mb-3 fw-400">
                                    {isConfirmed ? '企業情報の確認' : '企業情報を変更する'}
                                </div>
                                <Form id="company-form" className="form-theme h-adr">
                                    <div className="border-bottom-5-blue-04"></div>
                                    <div className="bg-ass-demo p-lg-5 p-3 mb-lg-5 mb-4">
                                        <div className="col-lg-8 col-11 px-0 mx-auto">
                                            <Form.Group className="form-group text-left mb-4">
                                                {
                                                    isConfirmed ?
                                                        <>
                                                            <Form.Label for="name1">企業名</Form.Label>
                                                            <hr className="mt-0 mb-2" />
                                                            <div className="text-theme fw-400">{name}</div>
                                                        </>
                                                        :
                                                        <>
                                                            <Form.Label for="name1">企業名<Image className="required-icon" src="assets/images/registration/required-icon.svg" /></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                onChange={(e) => setName(e.target.value)}
                                                                value={name}
                                                                disabled={isConfirmed}
                                                                className="form-control rounded-0"
                                                                name="name" required />
                                                        </>
                                                }
                                            </Form.Group>
                                            <Form.Group className="form-group text-left mb-4">

                                                {
                                                    isConfirmed ?
                                                        <>
                                                            <Form.Label for="name2">住所</Form.Label>
                                                            <hr className="mt-0 mb-2" />
                                                            <div className="text-theme fw-400">{postcode}</div>
                                                            <div className="text-theme fw-400">{pref}</div>
                                                            <div className="text-theme fw-400">{address1}</div>
                                                            <div className="text-theme fw-400">{address2}</div>

                                                        </> : <>
                                                            <label htmlFor="name2">住所<img className="img img-fluid required-icon" src="assets/images/registration/required-icon.svg" /></label>

                                                            <div className="input-group  text-left mb-4">
                                                                <input
                                                                    type="text"
                                                                    onChange={(e) => setPostcode(e.target.value)}
                                                                    value={postcode}
                                                                    disabled={isConfirmed}
                                                                    className="form-control rounded-0"
                                                                    id="postCode" name="post_code"
                                                                    placeholder="郵便番号から探す" required />
                                                                {/* TODO: Realize Search by postcode */}
                                                                {/* <div className="input-group-append">
                                                                    <button className="btn search-btn" id="searchBtn" type="button">
                                                                        <img src="/assets/images/registration/search-btn-bg-red.svg" />
                                                                    </button>
                                                                </div> */}
                                                            </div>



                                                            <Form.Group className="form-group text-left">
                                                                <Form.Select
                                                                    onChange={(e) => setPref(e.target.value)}
                                                                    value={pref}
                                                                    className="custom-select theme-form-select rounded-0"
                                                                    required id="pref" name="pref"
                                                                    disabled={isConfirmed}>
                                                                    <option value="">都道府県を選択してください</option>
                                                                    {prefs.map((prefItem: string, index: any) => (
                                                                        <option value={prefItem} selected={prefItem == pref}>{prefItem}</option>
                                                                    ))}
                                                                </Form.Select>




                                                            </Form.Group>
                                                            <Form.Group className="form-group  text-left">
                                                                <Form.Control
                                                                    type="text"
                                                                    className="form-control rounded-0"
                                                                    onChange={(e) => setAddress1(e.target.value)}
                                                                    value={address1}
                                                                    disabled={isConfirmed}
                                                                    id="address1" name="address1"
                                                                    placeholder="市区町村 番地" required />

                                                            </Form.Group>
                                                            <Form.Group className="form-group  text-left">

                                                                <Form.Control
                                                                    type="text"
                                                                    className="form-control rounded-0"
                                                                    onChange={(e) => setAddress2(e.target.value)}
                                                                    value={address2}
                                                                    disabled={isConfirmed}
                                                                    id="address2" name="address2"
                                                                    placeholder="ビル・マンション名など" />

                                                            </Form.Group>

                                                        </>
                                                }
                                            </Form.Group>


                                            <Form.Group className="form-group text-left mb-4">
                                                {
                                                    isConfirmed ?
                                                        <>
                                                            <Form.Label for="name33">電話番号</Form.Label>
                                                            <hr className="mt-0 mb-2" />
                                                            <div className="text-theme fw-400">{phone}</div>
                                                        </> :
                                                        <>
                                                            <Form.Label for="name33">電話番号<Image className="img img-fluid required-icon" src="/assets/images/registration/required-icon.svg" /></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                className="form-control rounded-0"
                                                                onChange={(e) => setPhone(e.target.value)}
                                                                value={phone}
                                                                disabled={isConfirmed}
                                                                name="phone"
                                                                placeholder="電話番号を入力" required />
                                                        </>


                                                }
                                            </Form.Group>
                                        </div>
                                    </div>
                                    {/* <button type="button" id="submit" className="btn btn-theme btn-danger rounded-pill px-lg-5 px-4 mb-5"><span className="px-lg-5 px-4">次へ</span></button> */}
                                    {!isConfirmed ? (
                                        <>
                                            <Button onClick={handleConfirm} id="submit" className="btn-theme btn-danger rounded-pill px-lg-5 px-4 mb-5 mr-3"><span className="px-lg-5 px-4">次へ</span></Button>
                                            <Link to="/account" className="btn btn-theme btn-secondary rounded-pill px-lg-5 px-4 mb-5"><span className="px-4">キャンセル</span></Link>
                                        </>
                                    ) : (
                                        <>
                                            <Button onClick={handleSubmit} className="btn-theme btn-danger rounded-pill px-4 mb-5 mr-2"><span className="px-4">この内容で変更する</span></Button>
                                            <Link to="#" onClick={() => { setIsConfirmed(false) }} className="btn btn-theme btn-secondary rounded-pill px-4 mb-5"><span className="px-4">入力内容を修正</span></Link>
                                        </>
                                    )}

                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default VendorEdit;